import React from 'react'
import Calendar from '../../components/calendar'

const EventView = (props) => (
  <Calendar {...props} />
)

export default EventView
